import InputDate from './input-date.component'

export default InputDate
